export const communityProjects = [
  {
    name: 'Arkived',
    slug: 'arkived',
    licencePath: 'LICENSE-APACHE',
    licence: 'Apache-2.0',
    upstream: null,
    en: 'A Rust-native storage client for Microsoft Azure. In development.',
    bs: 'Klijent za Microsoft Azure pohranu razvijen u Rustu. U razvoju.',
  },
  {
    name: 'Cozystack',
    slug: 'cozystack',
    licencePath: 'LICENSE',
    licence: 'Apache-2.0',
    upstream: 'cozystack/cozystack',
    en: 'A Kubernetes-based cloud platform. Horizon Tech’s public repository is a fork of the upstream project.',
    bs: 'Cloud platforma zasnovana na Kubernetesu. Horizon Tech ima javni fork izvornog projekta.',
  },
  {
    name: 'TileLang',
    slug: 'tilelang',
    licencePath: 'LICENSE',
    licence: 'MIT — see repository licence',
    upstream: 'tile-ai/tilelang',
    en: 'A language for GPU, CPU and accelerator kernels. Horizon Tech’s public repository is a fork of the upstream project.',
    bs: 'Jezik za GPU, CPU i akceleratorske kernele. Horizon Tech ima javni fork za rad na izvornom projektu.',
  },
] as const

export function communityProject(slug: string) {
  return communityProjects.find((project) => project.slug === slug)
}
export function projectRepository(project: (typeof communityProjects)[number]) {
  return `https://github.com/Horizon-Tech-doo/${project.slug}`
}
export function projectRepositories(
  project: (typeof communityProjects)[number],
) {
  return [
    projectRepository(project),
    ...(project.upstream ? [`https://github.com/${project.upstream}`] : []),
  ].flatMap((repo) => [repo.toLowerCase(), repo.toLowerCase() + '.git'])
}
